(() => {
  if (window.dormVibesHomepage) {
    window.dormVibesHomepage(document);
    return;
  }
  function initialize(scope) {
    const roots = scope.matches?.('[data-dvhome]') ? [scope] : scope.querySelectorAll('[data-dvhome]');
    roots.forEach(root => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const buttons = [...root.querySelectorAll('[data-room]')];
      const panels = [...root.querySelectorAll('[data-room-view]')];
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const selected = panels.find(panel => panel.dataset.roomView === button.dataset.room);
          if (!selected) return;
          buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          panels.forEach(panel => { panel.hidden = panel !== selected; });
          if (window.matchMedia('(max-width: 700px)').matches) {
            selected.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
          }
        });
      });
    });
  }
  window.dormVibesHomepage = initialize;
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
